export const getCompanyMenuLink = (route, lang) => route?.href ?? `/${lang}/${route.key}/`;


export const getRouteUrl = (lang, to) => {
  return `/${lang}${to}/`
}
